import {YearMonth} from '@domain/kpis'

export const formatYearMonth = (yearMonth: YearMonth) => {
  const monthFormatted = yearMonth.month.toString().padStart(2, '0')
  return `${yearMonth.year}-${monthFormatted}`
}
